/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminDebitOrCreditFuelRequestBody
 */
export interface AdminDebitOrCreditFuelRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AdminDebitOrCreditFuelRequestBody
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDebitOrCreditFuelRequestBody
     */
    amountInFuel?: number;
    /**
     * Setting this to true will add fuel, setting to false will credit fuel
     * @type {boolean}
     * @memberof AdminDebitOrCreditFuelRequestBody
     */
    debit: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDebitOrCreditFuelRequestBody
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDebitOrCreditFuelRequestBody
     */
    adminNote?: string;
}

/**
 * Check if a given object implements the AdminDebitOrCreditFuelRequestBody interface.
 */
export function instanceOfAdminDebitOrCreditFuelRequestBody(value: object): value is AdminDebitOrCreditFuelRequestBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('debit' in value) || value['debit'] === undefined) return false;
    return true;
}

export function AdminDebitOrCreditFuelRequestBodyFromJSON(json: any): AdminDebitOrCreditFuelRequestBody {
    return AdminDebitOrCreditFuelRequestBodyFromJSONTyped(json, false);
}

export function AdminDebitOrCreditFuelRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDebitOrCreditFuelRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amountInFuel': json['amountInFuel'] == null ? undefined : json['amountInFuel'],
        'debit': json['debit'],
        'note': json['note'] == null ? undefined : json['note'],
        'adminNote': json['adminNote'] == null ? undefined : json['adminNote'],
    };
}

export function AdminDebitOrCreditFuelRequestBodyToJSON(json: any): AdminDebitOrCreditFuelRequestBody {
    return AdminDebitOrCreditFuelRequestBodyToJSONTyped(json, false);
}

export function AdminDebitOrCreditFuelRequestBodyToJSONTyped(value?: AdminDebitOrCreditFuelRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'amountInFuel': value['amountInFuel'],
        'debit': value['debit'],
        'note': value['note'],
        'adminNote': value['adminNote'],
    };
}

